import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/apiAuth.jsx';
import { CompanyProvider } from './company/CompanyContext.jsx';
import { ToastProvider } from './components/Toast';
import ProtectedRoute from './auth/ProtectedRoute';
import SuperAdminRoute from './auth/SuperAdminRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Vendors from './pages/Vendors';
import VendorDetail from './pages/VendorDetail';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Orders from './pages/Orders';
import Sourcing from './pages/Sourcing';
import Quality from './pages/Quality';
import Reports from './pages/Reports';
import Import from './pages/Import';
import Admin from './pages/Admin';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="vendors" element={<Vendors />} />
                <Route path="vendors/:vendorNo" element={<VendorDetail />} />
                <Route path="products" element={<Products />} />
                <Route path="products/:id" element={<ProductDetail />} />
                <Route path="orders" element={<Orders />} />
                <Route path="sourcing" element={<Sourcing />} />
                <Route path="quality" element={<Quality />} />
                <Route path="reports" element={<Reports />} />
                <Route path="reports/:reportId" element={<Reports />} />
                <Route path="import" element={<SuperAdminRoute><Import /></SuperAdminRoute>} />
                <Route path="admin" element={<SuperAdminRoute><Admin /></SuperAdminRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </CompanyProvider>
    </AuthProvider>
  );
}

export default App;
